var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrive1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Uploaded to svgrepo.com",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.pictogram_vier{fill:#E54D2E;}\r\n\t.pictogram_een{fill:#F4D6B0;}\r\n\t.pictogram_twee{fill:#F8AD89;}\r\n\t.pictogram_zes{fill:#0C6667;}\r\n\t.pictogram_vijf{fill:#01A59C;}\r\n\t.st0{fill:#F8AD89;}\r\n\t.st1{fill:#F27261;}\r\n\t.st2{fill:#E54D2E;}\r\n\t.st3{fill:none;}\r\n\t.st4{fill:#01A59C;}\r\n\t.st5{fill:#008A74;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "pictogram_vier",
    cx: 16,
    cy: 16,
    r: 16
  }), /*#__PURE__*/React.createElement("path", {
    className: "pictogram_vijf",
    d: "M0,16v2h0.138C0.056,17.343,0,16.679,0,16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pictogram_vijf",
    d: "M32,18v-2c0,0.679-0.056,1.343-0.138,2H32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pictogram_vijf",
    d: "M21,0.808v16.069c0.877,0.303,1.718,0.679,2.519,1.123h8.343C31.944,17.343,32,16.679,32,16 C32,8.911,27.385,2.909,21,0.808z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pictogram_vijf",
    d: "M8.155,18c0.9-0.499,1.85-0.917,2.845-1.237V0.808C4.615,2.909,0,8.911,0,16 c0,0.679,0.056,1.343,0.138,2H8.155z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pictogram_zes",
    d: "M11,16.763C12.524,16.273,14.145,16,15.833,16c1.813,0,3.546,0.318,5.167,0.877V0.808 C19.426,0.29,17.748,0,16,0s-3.426,0.29-5,0.808V16.763z M14.5,3.5C14.5,2.672,15.171,2,16,2s1.5,0.672,1.5,1.5v2 C17.5,6.328,16.829,7,16,7s-1.5-0.672-1.5-1.5V3.5z M16,10c0.829,0,1.5,0.672,1.5,1.5v2c0,0.828-0.671,1.5-1.5,1.5 s-1.5-0.672-1.5-1.5v-2C14.5,10.672,15.171,10,16,10z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pictogram_een",
    d: "M14.5,13.5v-2c0-0.828,0.671-1.5,1.5-1.5s1.5,0.672,1.5,1.5v2c0,0.828-0.671,1.5-1.5,1.5 S14.5,14.328,14.5,13.5z M16,7c0.829,0,1.5-0.672,1.5-1.5v-2C17.5,2.672,16.829,2,16,2s-1.5,0.672-1.5,1.5v2 C14.5,6.328,15.171,7,16,7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pictogram_twee",
    d: "M23.519,18c-2.323-1.288-4.993-2-7.685-2c-3.394,0-6.711,1.118-9.417,3.1 c-2.068,1.515-3.303,3.03-4.337,4.77c0.554,0.977,1.21,1.885,1.95,2.72c1.773-3.84,5.065-6.495,8.971-7.313v7.354 c-1.632,0.812-2.663,2.347-3.034,4.182C11.829,31.573,13.864,32,16,32c2.021,0,3.946-0.39,5.726-1.074 C21.431,29.3,20.323,27.898,19,27.012v-7.562c3.685,0.98,7.088,3.616,8.741,7.394c0.764-0.827,1.441-1.733,2.018-2.708 C28.255,21.484,26.113,19.438,23.519,18z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrive1);
export default __webpack_public_path__ + "static/media/drive-1.c8d797ac0a7539f080cbf6af55ccae3e.svg";
export { ForwardRef as ReactComponent };